import { inject, Injectable } from '@angular/core';
import { TranslocoLoader } from '@ngneat/transloco';
import { TranslateService } from '../../../../libs/shared/core/src';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class EvasysTranslateLoader implements TranslocoLoader {
	//region Injections
	private readonly translateService = inject(TranslateService);

	//endregion

	/**
	 * Gets the translations from the server
	 */
	getTranslation(lang: string): Observable<any> {
		this.translateService.clear();
		return this.translateService.getTranslation(lang, ['ada', 'api-error', 'oadmin']);
	}
}
